import { useQueryClient } from "@tanstack/react-query";
import type { ConfirmTotpEnrollmentRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useConfirmTotpEnrollment() {
  const queryClient = useQueryClient();

  return useApiMutation("post", "/auth/mfa/totp/confirm", {
    notify: { error: false },
    invalidate: () => {
      queryClient.invalidateQueries({ queryKey: ["get", "/users/me"] });
    },
    mapVariables: (body: ConfirmTotpEnrollmentRequestDto) => ({ body }),
  });
}
